import { observer } from 'mobx-react';
import React from 'react';
import { cashbackStore } from '../../store/cashbackStore';
import { localeStore } from 'src/mobx/localesStore';
import { IValidation } from '~/types/main';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { InputWithTextInside } from '~/view/components/Controls/Inputs';
import Text from '~/view/components/Text/Text';
import './style.scss';

@observer
export default class CashbackCount extends React.Component<{}, {}> {
  state: Readonly<{ percentIsFocused: boolean }> = { percentIsFocused: false };

  onChangeCashback = (value: string | undefined) => {
    if (Number(value) > 100) return;
    cashbackStore.changeCashback({ percent: value });

    if (cashbackStore.validationErrors.percent) {
      cashbackStore.validatePercentage();
    }
  };

  onChangeMax = (value: string | undefined) => {
    cashbackStore.changeCashback({ max_cashback: value });
  };

  get percentValidation(): IValidation | undefined {
    if (cashbackStore.validationErrors.percent === null) return undefined;

    return { isValid: false, errorText: cashbackStore.validationErrors.percent };
  }

  handlePercentFocus = () => {
    this.setState({ percentIsFocused: true });
  };

  handlePercentBlur = () => {
    this.setState({ percentIsFocused: false });
  };

  render() {
    return (
      <div className="cashback-count">
        <Text
          type="block-header"
          text="cashback"
          required
          tooltip={{
            message: localeStore.t('cashback_percentage_settings_hint') + ' ' + localeStore.t('cashback_max_amount_hint'),
            position: TOOLTIP_POSITION.PORTAL,
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
          }}
        />

        <div className="d-flex flex-row mt-2 gap-10">
          <InputWithTextInside
            type="number"
            value={cashbackStore.cashback.percent || (this.state.percentIsFocused ? '' : '0')}
            onChangeValue={this.onChangeCashback}
            onFocus={this.handlePercentFocus}
            onBlur={this.handlePercentBlur}
            validation={this.percentValidation}
            maxLength={3}
            textProps={{ text: localeStore.t('cashback') + ' %', noTranslate: true, required: true }}
            className="cashback-count__input-percent"
          />

          <InputWithTextInside
            type="number"
            value={cashbackStore.cashback.max_cashback || '0'}
            onChangeValue={this.onChangeMax}
            textProps={{ text: 'max_cashback_amount' }}
            contentClassName="cashback-count__input-max"
          />
        </div>
      </div>
    );
  }
}
